/**
 * Shared seeded random utilities for generative nodes.
 *
 * LCG (Linear Congruential Generator) — fast, deterministic, good enough
 * for procedural layout and shuffling. Not cryptographic.
 */

/** Returns a seeded PRNG function producing values in [0, 1). */
export function seededRandom(seed: number): () => number {
  let s = seed | 0;
  return () => {
    s = (s * 1664525 + 1013904223) | 0;
    return (s >>> 0) / 0xffffffff;
  };
}
